import type { ComponentType } from 'react';
import type { PanelScreen, PanelScreenConfig, ReportConfig } from './types/panelConfig';
import { SatisAnaliz } from './pages/SatisAnaliz';
import StokAnalizi from './pages/StokAnalizi';
import CariHesapListesi from './pages/CariHesapListesi';
import StokDegerRaporu from './pages/StokDegerRaporu';
import StokCikisRaporu from './pages/StokCikisRaporu';
import HamamPerformans from './pages/HamamPerformans';
import { WidgetSayfasi } from './pages/WidgetSayfasi';

export interface EkranProps {
  screen: PanelScreen;
  reports: ReportConfig[];
}

const DEFTER: Record<string, ComponentType<EkranProps>> = {
  'satis-analiz': SatisAnaliz,
  'stok-analiz': StokAnalizi,
  // S334: ERP12 rapor ekranları (elle yazılmış; kaynakları `config.kaynaklar`dan).
  'cari-hesap-listesi': CariHesapListesi,
  // S345: Stok Değer ve Stok Çıkış raporları.
  'stok-deger': StokDegerRaporu,
  'stok-cikis': StokCikisRaporu,
  // S340: Osmanlı Hamamı performans ekranı (kaynakları `config.kaynaklar`dan).
  'hamam-performans': HamamPerformans,
};

/**
 * screen_key → sayfa bileşeni.
 * Bilinmeyen anahtar SatisAnaliz'e düşer: App.tsx bu defter açılmadan önce TÜM ekranları
 * koşulsuz SatisAnaliz'e bağlıyordu ve Template paneli 10 firmada ortak — davranış korunur.
 */
export function ekranBileseni(key: string, config?: PanelScreenConfig | null): ComponentType<EkranProps> {
  // S312: tür, anahtardan önce gelir; `tur` alanı olmayan eski config'ler için davranış aynı.
  if (config?.tur === 'widget-sayfasi') return WidgetSayfasi;
  return DEFTER[key] ?? SatisAnaliz;
}
